import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const DEFAULT_TITLE = 'Mevius';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "history" */ '../views/History.vue'),
    meta: {unauthorizedAllowed: false},
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {unauthorizedAllowed: true},
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import(/* webpackChunkName: "reset" */ '../views/Reset.vue'),
    props: {step: 1},
    meta: {unauthorizedAllowed: true}
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    props: true,
    meta: {unauthorizedAllowed: true},
    children: [
      {
        path: ':catchAll(.*)',
        redirect: '/register'
      }
    ],
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import(/* webpackChunkName: "feedback" */ '../views/Feedback.vue'),
    meta: {bannedAllowed: true, unauthorizedAllowed: true},
  },
  // {
    // path: '/register/final',
    // name: 'registerFinal',
    // component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    // props: {step: 6},
    // meta: {requiresRegisterFinal: true, unauthorizedAllowed: true}
  // },
  // {
    // path: '/register/info-about-passport-check',
    // name: 'info-passport-check',
    // component: () => import(/* webpackChunkName: "info-passport-check" */ '../views/InfoAboutPassportCheck.vue'),
    // meta: {requiresAuth: false, unauthorizedAllowed: true}
  // },
  // {
    // path: '/register/some-info',
    // component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    // meta: {requiresAuth: false, unauthorizedAllowed: true},
    // children: [{
      // path: '',
      // name: 'profile-fields',
      // component: () => import(/* webpackChunkName: "profileForm" */ '../components/profile/ProfileForm.vue')
    // }]
  // },
  // {
    // path: '/register/consumption-survey',
    // name: 'register-consumption-survey',
    // component: () => import(/* webpackChunkName: "consumptionSurvey" */ '../views/ConsumptionSurvey.vue'),
    // meta: {requiresAuth: false, unauthorizedAllowed: true},
  // },
  {
    path: '/products/:id',
    name: 'products-detail',
    component: () => import(/* webpackChunkName: "productsDetail" */ '../views/ProductsDetail.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/blocked',
    name: 'blocked',
    component: () => import(/* webpackChunkName: "blocked" */ '../views/Blocked.vue'),
    meta: {bannedAllowed: true},
  },
  {
    path: '/cabinet',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    children: [
      {
        path: '',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profileForm" */ '../components/profile/ProfileForm.vue'),
        meta: {requiresAuth: true},
      },
      // {
        // path: '/cabinet/update',
        // name: 'profile-update',
        // component: () => import(/* webpackChunkName: "profileUpdate" */ '../components/profile/ProfileUpdate.vue'),
      // },
      {
        path: '/cabinet/documents',
        name: 'profile-documents',
        component: () => import(/* webpackChunkName: "profileDocuments" */ '../components/profile/ProfileDocuments.vue'),
        meta: {unauthorizedAllowed: true, requiresAuth: false},
      },
      // {
        // path: '/cabinet/password',
        // name: 'profile-password',
        // component: () => import(/* webpackChunkName: "profilePassword" */ '../components/profile/ProfilePassword.vue'),
      // },
      {
        path: '/cabinet/delete',
        name: 'profile-delete',
        component: () => import(/* webpackChunkName: "profileDelete" */ '../components/profile/ProfileDelete.vue'),
      },
      {
        path: '/cabinet/subscribe',
        name: 'profile-subscribe',
        component: () => import(/* webpackChunkName: "profileSubsctibe" */ '../components/profile/ProfileSubscribe.vue'),
        meta: {requiresAuth: true},
      },
      // {
        // path: '/cabinet/activity',
        // name: 'activity',
        // component: () => import(/* webpackChunkName: "profileActivity" */ '../components/profile/ProfileActivity.vue'),
      // },
      // любой несуществующий дочерний путь заменяется на /cabinet
      {
        path: ':catchAll(.*)',
        redirect: '/cabinet',
        meta: {requiresAuth: true},
      }
    ],
    // TODO: вернуть после объединения ветки DJTIMEV-381 и мастера
    //meta: {requiresAuth: true},
  },
  // {
    // path: '/consumption-survey',
    // name: 'consumption-survey',
    // props: true,
    // component: () => import(/* webpackChunkName: "consumptionSurvey" */ '../views/ConsumptionSurvey.vue'),
    // meta: {requiresAuth: true},
  // },
  {
    path: '/email-confirm',
    name: 'email-confirm',
    component: () => import(/* webpackChunkName: "emailConfirm" */ '../views/EmailConfirm.vue'),
    meta: {unauthorizedAllowed: true},
  },

  {
    path: '/archive/portal/',
    name: 'archive-main',
    component: () => import(/* webpackChunkName: "portalMain" */ '../views/PortalMainArchive.vue'),
    meta: {
      title: 'Портал(Архив)',
    },
  },
  {
    path: '/portal',
    name: 'portal-main',
    component: () => import(/* webpackChunkName: "portalMain" */ '../views/PortalMain.vue'),
    meta: {
      title: 'Портал',
    },
  },
  {
    path: '/portal/surveys',
    name: 'portal-surveys',
    component: () => import(/* webpackChunkName: "portalSurveyList" */ '../views/PortalQuestionnaire.vue'),
    meta: {
      title: 'Опросы',
    },
  },
  {
    path: '/archive/portal/surveys',
    name: 'archive-surveys',
    component: () => import(/* webpackChunkName: "portalSurveyList" */ '../views/PortalQuestionnaire.vue'),
    meta: {
      title: 'Опросы',
    },
  },
  {
    path: '/portal/surveys/:code',
    name: 'portal-survey-detail',
    component: () => import(/* webpackChunkName: "portalSurveyDetail" */ '../views/PortalSurvey.vue'),
  },
  {
    path: '/portal/articles',
    name: 'portal-articles',
    component: () => import(/* webpackChunkName: "portalArticles" */ '../views/PortalArticles.vue'),
    meta: {
      title: 'Статьи',
    },
  },
  {
    path: '/archive/portal/articles',
    name: 'archive-articles',
    component: () => import(/* webpackChunkName: "portalArticles" */ '../views/PortalArticles.vue'),
    meta: {
      title: 'Статьи',
    },
  },
  {
    path: '/portal/articles/:code',
    name: 'portal-articles-detail',
    component: () => import(/* webpackChunkName: "portalArticles" */ '../views/ArticleDetail.vue'),
  },
  {
    path: '/portal/tests',
    name: 'portal-tests',
    component: () => import(/* webpackChunkName: "portalTest" */ '../views/PortalTest.vue'),
    meta: {
      title: 'Тесты',
    },
  },
  {
    path: '/archive/portal/tests',
    name: 'archive-tests',
    component: () => import(/* webpackChunkName: "portalTest" */ '../views/PortalTest.vue'),
    meta: {
      title: 'Тесты',
    },
  },
  {
    path: '/portal/tests/:code',
    name: 'portal-tests-detail',
    component: () => import(/* webpackChunkName: "portalMain" */ '../views/TestDetail.vue'),
  },
  {
    path: '/portal/test/item',
    name: 'portal-test-detail-item',
    component: () => import(/* webpackChunkName: "portalMain" */ '../views/TestDetailItem.vue'),
  },
  {
    path: '/portal/nonograms',
    name: 'portal-nonograms',
    component: () => import(/* webpackChunkName: "NonogramDetail" */ '../views/NonogramDetail.vue'),
    meta: {
      title: 'Нонограммы',
    },
  },
  {
    path: '/portal/nonograms/:code',
    name: 'portal-nonograms-detail',
    component: () => import(/* webpackChunkName: "NonogramDetail" */ '../views/NonogramDetail.vue'),
  },
  /*{
    path: '/portal/confidentiality',
    name: 'portal-confidentiality',
    component: () => import(/!* webpackChunkName: "PortalConfidentiality" *!/ '../views/PortalConfidentiality.vue'),
  },*/
  {
    path: '/new-year/ny2023',
    name: '2023',
    component: () => import(/* webpackChunkName: "NewYear2023" */ '../views/NewYear2023.vue'),
  },
  {
    path: '/history',
    name: 'history',
    component: () => import(/* webpackChunkName: "history" */ '../views/History.vue'),
    meta: {bannedAllowed: false, unauthorizedAllowed: false},
  },
  {
    path: '/contractors',
    name: 'contractors',
    component: () => import(/* webpackChunkName: "contractors" */ '../views/Contractors.vue'),
    meta: {bannedAllowed: true, unauthorizedAllowed: true},
  },
  {
    path: '/age',
    name: 'age',
    component: () => import(/* webpackChunkName: "age" */ '../views/Age.vue'),
    meta: {bannedAllowed: true, unauthorizedAllowed: true},
  },
  {
    path: '/authentication-fail',
    name: 'authentication-fail',
    component: () => import(/* webpackChunkName: "age" */ '../views/AuthenticationFail.vue'),
    meta: {bannedAllowed: false, unauthorizedAllowed: true},
  },
  {
    path: '/pending-verification',
    name: 'pending-verification',
    component: () => import(/* webpackChunkName: "pendingVerification" */ '../views/PendingVerification.vue'),
    meta: {bannedAllowed: false, unauthorizedAllowed: false},
  },
  {
    path: '/t',
    name: 'email-link',
    component: () => import(/* webpackChunkName: "age" */ '../views/EmailLink.vue'),
    meta: {bannedAllowed: true, unauthorizedAllowed: true},
  },
  {
    path: "*",
    name: '404',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/404.vue'),
    meta: {unauthorizedAllowed: true},
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/', //process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
});

router.beforeEach(async (to, from, next) => {
  // если метод запускается впервые
  if (!store.state.isBeforeEachFirstRunDone) {
    // устанавливаем флаг, чтобы больше не запускать этот блок
    store.commit('setBeforeEachFirstRunDone');
    // проверка аутентификации, если активна сессия, сохранить профиль пользователя и сегменты
    await store.dispatch('checkAuthentication');
  }

  // user conditions
  const isUserBlocked = () => {
    return store.getters.isUserBanned;
  };

  const isAgeConfirmed = () => {
    const result = store.getters.isAgeConfirmed;
    return result;
  };

  const isRouteAge = () => {
    const result = to.name === 'age';
    return result;
  };

  const isSegmentTrade = () => store.getters.isSegmentTrade;

  const isSegmentDocumentsRequired = () => store.getters.needPassport;

  const isSegmentDocumentsProcessed = () => store.getters.isPassportBeingProcessed;

  const isRouteDocumentsTab = () =>
    to.name === 'profile-documents';

  const isRouteUnrestricted = () =>
    to.name === 'age' ||
    to.name === 'login' ||
    to.name === 'register' ||
    to.name === 'feedback';

  /*
  const isRouteAuthenticationFail = () => {
    const result = to.name === 'authentication-fail';
    return result;
  };
  */

  // redirects
  function gotoDefaultProduct() {
    next({path: '/products/lss-original'});
  }

  function gotoBlocked() {
    next({name: 'blocked'});
  }

  /*
  function gotoRegister() {
    next({name: 'register'});
  }
   */

  function gotoLogin(query) {
    next({name: 'login', query: query});
  }

  function gotoAge(query) {
    next({name: 'age', query: query});
  }

  function gotoHome() {
    next({name: 'home'});
  }

  function gotoDocumentsTab() {
    next({path: '/cabinet/documents'});
  }

  /*
  function gotoAuthenticationFail() {
    next({path: '/authentication-fail'});
  }
  */

  /*
    3 степени авторизации:
    - signed-out: checkAuthentication не возвращает профиль пользователя
    - unauthenticated: профиль пользователя приходит, но auth: 'fail'
    - authenticated: есть профиль пользователя и auth: 'Success'
   */
  const accessType = store.getters.accessType;
  /*
    виды пользователей:
    - default: обычный
    - trade: из канала trade, может перемещаться по всем страницам
    - products-only: доступны только продуктовые страницы
   */
  const userType = store.getters.userType;

  // редирект многих роутов на один целевой
  // если пользователь заблокирован, то переводить на страницу блокировки
  if (accessType !== 'signed-out' && isUserBlocked() && !(to.name === 'blocked')) {
    gotoBlocked();
    return;
  }

  // если пользователь не авторизован, обязательно подтверждать возраст
  if (accessType !== 'authenticated' && !isAgeConfirmed() && !isUserBlocked()) {
    if (isRouteAge()) {
      if (to.query.next) {
        next();
      } else {
        gotoAge({next: '/login'});
      }
    } else {
      gotoAge({next: to.fullPath});
    }
    return;
  }

  // если стандартный пользователь не авторизован и не загрузил документы, редирект на вкладку документов в ЛК
  if (
    !isSegmentTrade() && // пользователь из сегмента TRADE может посещать все страницы
    isSegmentDocumentsRequired() &&
    !isRouteDocumentsTab() &&
    !isRouteUnrestricted()
  ) {
    gotoDocumentsTab();
    return;
  }

  // TODO: объединить этот и предыдущий блоки
  // если стандартный пользователь загрузил документы, и они на проверке, редирект на вкладку документов в ЛК
  if (
    !isSegmentTrade() && // пользователь из сегмента TRADE может посещать все страницы
    !isSegmentDocumentsRequired() &&
    isSegmentDocumentsProcessed() &&
    !isRouteDocumentsTab() &&
    !isRouteUnrestricted()
  ) {
    gotoDocumentsTab();
    return;
  }

  const redirect = data => {
    if (typeof data === 'function') {
      data();
    } else if (typeof data === 'object') {
      if (data.check) {
        if (data.check()) {
          next({name: data.redirect});
        } else {
          next();
        }
      } else if (data.userTypes) {
        redirect(data.userTypes[userType]);
      } else if (data.accessTypes) {
        redirect(data.accessTypes[accessType]);
      }
    }
  }

  // редиректы одного целевого роута на многие
  switch (to.name) {
    case 'age':
    case 'login':
    case 'register':
      redirect({
        accessTypes: {
          'signed-out': next,
          'unauthenticated': next,
          'authenticated': gotoHome,
        }
      });
      return;
    case 'blocked':
      redirect({
        accessTypes: {
          'signed-out': gotoHome,
          'unauthenticated': { check: () => !isUserBlocked(), redirect: 'login' },
          'authenticated': { check: () => !isUserBlocked(), redirect: 'home' },
        }
      });
      return;
    case 'feedback':
      next();
      return;
    case 'profile':
    case 'profile-subscribe':
      redirect({
        accessTypes: {
          'signed-out': gotoLogin,
          'unauthenticated': {
            userTypes: {
              'default': gotoLogin,
              'trade': next,
              'products-only': gotoDefaultProduct,
            }
          },
          'authenticated': {
            userTypes: {
              'default': next,
              'trade': next,
              'products-only': gotoDefaultProduct,
            }
          },
        }
      });
      return;
    case 'profile-documents':
      redirect({
        accessTypes: {
          'signed-out': gotoLogin,
          'unauthenticated': {
            userTypes: {
              'default': next,
              'trade': gotoHome,
              'products-only': gotoDefaultProduct,
            }
          },
          'authenticated': {
            userTypes: {
              'default': gotoLogin,
              'trade': gotoHome,
              'products-only': gotoDefaultProduct,
            }
          },
        }
      });
      return;
    case 'products-detail':
      redirect({
        accessTypes: {
          'signed-out': gotoLogin,
          'unauthenticated': {
            userTypes: {
              'default': gotoLogin,
              'trade': next,
              'products-only': next,
            }
          },
          'authenticated': next
        }
      });
      return;
    case 'home':
    case 'history':
      redirect({
        accessTypes: {
          'signed-out': gotoLogin,
          'unauthenticated': {
            userTypes: {
              'default': gotoLogin,
              'trade': next,
              'products-only': gotoDefaultProduct,
            }
          },
          'authenticated': {
            userTypes: {
              'default': next,
              'trade': next,
              'products-only': gotoDefaultProduct,
            }
          }
        }
      });
      return;
  }

  next();
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
